<div class="truth-management-container">
  @if (!showTruthValuesPage) {
    <!-- Main Management Page with Header and Navigation -->
    
    <!-- Page Header Component -->
    <app-page-header></app-page-header>

    <div class="evaluation-section-header">
      <div class="evaluation-section-title-wrap">
        <button
          class="header-back-btn section-back-btn"
          (click)="router.navigate(['/dashboard'])"
          title="Back to Evaluation"
          aria-label="Back to Evaluation">
          <svg
            class="back-arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
        <h2 class="evaluation-section-title">Ground Truth Coverage</h2>
      </div>
    </div>

    <!-- Main Management Page - Three Column Layout -->
    <div class="content-grid" [class.file-column-collapsed]="isFileColumnCollapsed">
      
      <!-- Column 1: Files Section -->
      <section class="column files-column" [class.collapsed]="isFileColumnCollapsed">
        <!-- Collapsed State: Show selected file indicator -->
        @if (isFileColumnCollapsed && selectedFile) {
          <div class="collapsed-file-indicator" (click)="toggleFileColumn()" [title]="selectedFile.fileName">
            <button class="btn-expand-files" title="Expand file list">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
            <div class="selected-file-name-vertical">
              <span>{{ selectedFile.fileName }}</span>
            </div>
          </div>
        }
        
        <!-- Expanded State: Show full file list -->
        <div class="card" [class.hidden]="isFileColumnCollapsed">
          <!-- Document Title with Upload Button -->
          @if (selectedDocument) {
            <div class="document-header">
              <h3 class="document-title" title="{{ selectedDocument.documentNumber }} ({{ files.length }} {{ files.length === 1 ? 'File' : 'Files' }})">{{ selectedDocument.documentNumber }} ({{ files.length }} {{ files.length === 1 ? 'File' : 'Files' }})</h3>
              @if (selectedFile && !authService.isReadOnly) {
                <button class="btn-collapse-files" (click)="toggleFileColumn()" title="Collapse file list">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
              }
              <input 
                type="file" 
                #fileInput 
                (change)="onFileSelectedAndUpload($event)" 
                accept=".pdf" 
                style="display: none" 
                multiple>
              <button *ngIf="!authService.isReadOnly" class="btn-download-all" (click)="fileInput.click()" [disabled]="isUploadingFile" title="Upload files">
                @if (isUploadingFile) {
                  <div class="btn-spinner-small"></div>
                } @else {
                  <span class="material-icons">upload</span>
                }
              </button>
              <button *ngIf="isAdmin && !authService.isReadOnly && files.length > 0"
                      class="btn-download-all"
                      (click)="downloadFiles()"
                      [disabled]="isDownloadingFiles"
                      title="Download all files as ZIP">
                @if (isDownloadingFiles) {
                  <div class="btn-spinner-small"></div>
                } @else {
                  <span class="material-icons">download</span>
                }
              </button>
            </div>
            <!-- Search bar for samples -->
@if (selectedDocument && files.length > 0) {
  <div class="file-search-container">
    <div class="search-input-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input 
        type="text" 
        [(ngModel)]="fileSearchTerm" 
        placeholder="Search sample" 
        class="file-search-input"
        autocomplete="off">
      @if (fileSearchTerm) {
        <button class="clear-search-btn" (click)="fileSearchTerm = ''" title="Clear search">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      }
    </div>
  </div>
}
          }

          <div class="file-tree">
            @if (selectedDocument) {
              @if (loadingEvalFiles) {
                <div class="files-loading-state">
                  <div class="beat-loader">
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                  </div>
                  <span class="loading-text">Loading files...</span>
                </div>
              } @else if (filteredFiles.length > 0) {
                @for (file of filteredFiles; track file.id) {
                  <div class="tree-item file-item" 
                       [class.selected]="selectedFile?.id === file.id"
                       (click)="selectFileOnly(file)"
                       [title]="file.fileName">
                    <div class="tree-row">
                      <span class="status-dot-container">
                        @if (getFileStatus(file.id)) {
                          <span class="status-dot"
                                [class]="'status-dot ' + getFileStatusClass(file.id)"
                                [title]="getFileStatus(file.id)?.tooltip"
                                role="status"
                                [attr.aria-label]="getFileStatus(file.id)?.tooltip">
                          </span>
                        }
                        @if (isFileExtracting(file.id)) {
                          <span class="autofill-progress-overlay" 
                                title="Auto-filling in progress..."
                                role="status"
                                aria-label="Auto-filling in progress">
                          </span>
                        }
                        @if (!isFileExtracting(file.id) && isFileAutoFillCompleted(file.id)) {
                          <span class="autofill-complete-indicator"
                            [class]="'autofill-complete-indicator ' + getFileStatusClass(file.id)"
                                title="Auto-fill completed"
                                role="status"
                                aria-label="Auto-fill completed">
                          </span>
                        }
                      </span>
                      <svg class="file-icon pdf-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                      </svg>
                      <span class="tree-label">{{ file.fileName }}</span>
                      <div class="file-actions">
                        @if (isAdmin && !authService.isReadOnly) {
                          <button class="btn-icon-action btn-download-file"
                            (click)="downloadFile($event, file)"
                            [title]="'Download ' + file.fileName">
                            <span class="material-icons">download</span>
                          </button>
                          <button class="btn-icon-action btn-delete-file" 
                                  (click)="deleteFile($event, file)" 
                                  [title]="'Delete ' + file.fileName">
                            <span class="material-icons">delete</span>
                          </button>
                      }
                      </div>
                    </div>
                  </div>
                }
              } @else if (files.length > 0 && filteredFiles.length === 0) {
                <div class="empty-state-small">
                  <p>No matching files found</p>
                  <p class="empty-subtitle">Try a different search term</p>
                </div>
              } @else {
                <div class="empty-state-small">
                  <p>No PDF files uploaded yet</p>
                  <p class="empty-subtitle">Click Upload to add files</p>
                </div>
              }
            } @else {
              <div class="empty-state-small">
                <p>Select a document from Accuracy page</p>
              </div>
            }
          </div>
        </div>
      </section>

      <!-- Columns 2 & 3: PDF Viewer and Truth Values, with a draggable divider between them -->
      <div class="viewer-attributes-wrapper" [style.grid-template-columns]="'minmax(400px, ' + splitPosition + 'fr) 20px minmax(420px, ' + (100 - splitPosition) + 'fr)'">

      <!-- Column 2: PDF Viewer -->
      <section class="column viewer-column">
        <div class="card viewer-card">
          <div class="viewer-header-inline">
            <h2 class="card-title">Preview</h2>
            <div class="viewer-controls-inline">
              <div class="page-controls">
                <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1" title="Previous Page">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <input 
                  type="text" 
                  class="page-input"
                  [(ngModel)]="pageInput"
                  (blur)="goToPage()"
                  (keydown)="onPageInputKeydown($event)"
                  [disabled]="!pdfSrc"
                  title="Go to page">
                <span class="page-separator">/</span>
                <span class="page-total">{{ totalPages || 0 }}</span>
                <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages" title="Next Page">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
              <div class="zoom-controls">
                <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5" title="Zoom Out">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </button>
                <input 
                  type="text" 
                  class="zoom-input"
                  [(ngModel)]="zoomPercentage"
                  (blur)="setZoomByPercentage()"
                  (keydown)="onZoomInputKeydown($event)"
                  [disabled]="!pdfSrc"
                  title="Enter zoom percentage (50-300)">
                <span class="zoom-percent-sign">%</span>
                <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0" title="Zoom In">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="11" y1="8" x2="11" y2="14"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </button>
              </div>
              <div class="rotate-controls">
                <button class="control-btn rotate-btn" (click)="rotatePdf()" [disabled]="!pdfSrc" title="Rotate 90° clockwise">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"></path>
                    <path d="M21 3v5h-5"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Warm-cache progress line loader; hidden until download starts and after it hits 100 -->
          <div class="pdf-progress"
               [style.display]="pdfLoadProgress > 0 && pdfLoadProgress < 100 ? 'flex' : 'none'">
            <span class="pdf-progress-label">Loading document {{ pdfLoadProgress }}%</span>
            <span class="pdf-progress-track">
              <span class="pdf-progress-fill" [style.width.%]="pdfLoadProgress"></span>
            </span>
          </div>

          <div class="pdf-container" #pdfContainer (click)="onPdfContainerClick($event)">
            <ng-container #snipHost></ng-container>
            @if (!pdfSrc && !isLoadingPdf) {
              <div class="empty-state">
                <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
                <p>No document loaded</p>
                <p class="empty-subtitle">Upload a PDF to preview</p>
              </div>
            }

            @if (isLoadingPdf) {
              <div class="pdf-loading-state">
                <div class="loading-icon-wrapper">
                  <div class="beat-loader">
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                  </div>
                </div>
                <p class="loading-text">Loading document...</p>
              </div>
            }

            @if (pdfSrc) {
              <!-- Lazy-loading PDF viewer (CDK virtual scroll + per-page canvases).
                   Document loading happens in startPdfDocumentLoad(); this component
                   only renders the pages near the viewport. bufferViewports 1.5 =
                   ~3-4 pages ahead/behind prefetched for smooth scrolling. -->
              <app-pdf-lazy-viewer
                [pdfDoc]="pdfDocument"
                [pageNumbers]="pageNumbers"
                [pageWidthsPx]="pageWidthsPx"
                [pageHeightsPx]="pageHeightsPx"
                [pageScales]="pageScales"
                [pageRotations]="pageRotations"
                [pageGapPx]="pageGapPx"
                [pxPerRem]="pxPerRem"
                [bufferViewports]="1.5"
                (scrolledIndexChange)="onLazyScrolledIndex($event)"
                (pageRendered)="onLazyPageRendered($event)" />
            }
          </div>
        </div>
      </section>

      <!-- Draggable Divider -->
      <div class="resize-divider"
           (mousedown)="startResize($event)"
           [class.dragging]="isDragging"
           title="Drag to resize panels">
        <div class="divider-handle"></div>
      </div>

      <!-- Column 3: Truth Values Feed -->
      <section class="column attributes-column">
        <div class="card truth-values-card">
          <div class="title-with-button">
            <div class="title-group">
              <h2 class="card-title"
                  [title]="selectedDocument && selectedFile && attributes.length > 0
                    ? 'Truth Values (' + getHeaderCount().filled + '/' + getHeaderCount().total + ')'
                    : 'Truth Values'">
                Truth Values
                @if (selectedDocument && selectedFile && attributes.length > 0) {
                  <span class="field-count" [title]="getHeaderCount().filled + ' filled out of ' + getHeaderCount().total + ' total fields'">({{ getHeaderCount().filled }}/{{ getHeaderCount().total }})</span>
                }
              </h2>
            </div>
            @if (selectedDocument && selectedFile) {
              <div class="action-buttons-container">
                @if (hasUnsavedChanges()) {
                  <button class="btn-save-changes" 
                          (mousedown)="$event.preventDefault()"
                          (click)="saveAllChanges()"
                          [disabled]="isCurrentFileExtracting()">
                    <span class="material-icons">save</span>
                    Save Changes
                    @if (getUnsavedCount() > 0) {
                      <span> ({{ getUnsavedCount() }})</span>
                    }
                  </button>
                } @else {
                  <button *ngIf="!authService.isReadOnly" class="btn-auto-fill" 
                          (click)="triggerManualAutoFill()"
                          [disabled]="isCurrentFileExtracting()"
                          [title]="isCurrentFileExtracting() ? 'Auto-fill in progress for this file...' : 'Auto-fill empty fields from document'">
                    @if (isCurrentFileExtracting()) {
                      <span class="btn-spinner-small"></span>Auto filling...
                    } @else {
                      <span class="material-icons">auto_fix_high</span>Auto Fill
                    }
                  </button>
                }
              </div>
            }
          </div>

          <!-- Search Filter -->
          @if (selectedDocument && selectedFile && attributes.length > 0) {
            <div class="attribute-search-container">
              <div class="search-input-wrapper">
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0z"></path>
                  <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <input 
                  type="text" 
                  [(ngModel)]="attributeSearchTerm"
                  placeholder="Search attributes..."
                  class="attribute-search-input">
                @if (attributeSearchTerm) {
                  <button class="clear-search-btn" (click)="attributeSearchTerm = ''" title="Clear search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                }
              </div>
            </div>
          }

          <div class="truth-values-feed">
            @if (selectedDocument && selectedFile) {
              @if (attributes.length > 0 && filteredAttributes.length > 0) {
                @for (attribute of filteredAttributes; track attribute.id; let isFirst = $first) {
                  <div class="attribute-value-pair" 
                       [class.has-source]="hasSourceData(attribute.id!)"
                       (click)="onAttributeFieldClick(attribute.id!)">
                    <!-- Attribute Header -->
                    <div class="attribute-header">
                      <div class="attribute-info">
                        <span class="attribute-indicator" [class.valid]="isValueValid(attribute.id!) === 'valid'" [class.invalid]="isValueValid(attribute.id!) === 'invalid'">{{ getValueIndicator(attribute.id!) }}</span>
                        <div class="attribute-name">
                          <div class="attribute-label">
                            <span class="label-text" [title]="attribute.attributeLabel">{{ attribute.attributeLabel }}</span>
                            @if (!attribute.isTableField) {
                              <span class="attribute-prompt-icon"
                                    (mouseenter)="showTooltip($event, attribute.prompt || attribute.description || '')"
                                    (mouseleave)="hideTooltip()">
                                <img src="information_icon.png" alt="Info" width="14" height="14">
                              </span>
                            }
                          </div>
                        </div>
                      <!-- Array Add Button (appears before toggle for array attributes) -->
                    <!-- Array Add Button (appears before toggle for array attributes) -->
                        @if (attribute.is_array) {
                          <button class="btn-add-truth-value"
                                  (click)="addNewValueBox(attribute.id!); $event.stopPropagation()"
                                  [disabled]="authService.isReadOnly || isCurrentFileExtracting() || isNotApplicable(attribute.id!)"
                                  [title]="authService.isReadOnly ? 'Read-only access' :
                                          isNotApplicable(attribute.id!) ? 'Enable field to add values' :
                                          isCurrentFileExtracting() ? 'Cannot add during auto-fill' : 'Add New Value'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          </button>
                        }
                      <!-- N/A Toggle - INVERTED BEHAVIOR: Toggle ON = Enabled, Toggle OFF = N/A -->
                      <!-- Always positioned at right end for consistency -->
                      <label class="na-toggle" [title]="!isNotApplicable(attribute.id!) ? 'Field value available in the PDF' : 'Field value NOT available in the PDF'">
                        <input type="checkbox" 
                          [checked]="!isNotApplicable(attribute.id!)"
                          (change)="toggleNotApplicable(attribute.id!)"
                          [disabled]="isCurrentFileExtracting()">
                        <span class="na-toggle-slider"></span>
                      </label>
                      </div>
                    </div>

                    <!-- Truth Values Display/Edit -->
                    <div class="truth-value-container">
                      @if (attribute.isTableField && attribute.tableColumns) {
                        <!-- Table field rendering - dictionary-based storage -->
                        <app-table-row-input
                          [columns]="attribute.tableColumns"
                          [tableData]="getTableDataValue(attribute)"
                          [attributeId]="attribute.id!"
                          [isReadOnly]="authService.isReadOnly"
                          [isExtracting]="isCurrentFileExtracting()"
                          [isAutoPopulated]="isAutoPopulated(attribute.id!)"
                          [isOverridden]="isOverridden(attribute.id!)"
                          [hasAutoFilledBoundingBox]="hasAutoFilledBoundingBoxIndicator(attribute.id!)"
                          [cellBboxKeys]="getTableCellBboxSet(attribute.id!)"
                          [canSnip]="canSnipForAttribute(attribute.id!)"
                          [pendingSnipIndices]="getTablePendingSnipIndices(attribute.id!)"
                          (tableDataChanged)="onTableDataChanged(attribute.id!, $event)"
                          (rowAdded)="onTableRowAdded(attribute.id!)"
                          (rowRemoved)="onTableRowRemoved(attribute.id!)"
                          (rowEdited)="onTableRowEdited(attribute.id!, $event)"
                          (cellEditingChanged)="onTableCellEditingChanged($event)"
                          (cellClicked)="onTableCellClicked(attribute.id!, $event)"
                          (snipToggleClicked)="onTableSnipToggleClicked(attribute.id!, $event)"
                          (tableReverted)="onTableReverted(attribute.id!)">
                        </app-table-row-input>
                      } @else if (isArrayValue(attribute.id!)) {
                        <div class="value-boxes">
                          @if (getDisplayValueAsArray(attribute.id!).length > 0) {
                            @for (valuePart of getDisplayValueAsArray(attribute.id!); track $index; let valueIndex = $index) {
                              @if (editingAttributeId === attribute.id && editingArrayIndex === valueIndex) {
                                <div class="truth-value-wrapper">
                                  <div class="value-box-edit">
                                    @if (getFieldType(attribute.id!) === 'date') {
                                      <div class="date-input-wrapper">
                                        <input
                                          #editingInput
                                          type="text"
                                          class="truth-value-edit-input date-input"
                                          [value]="editingTruthValueText"
                                          (input)="formatDateForInput($event, attribute.id!)"
                                          (keydown)="onDateKeydown($event, attribute.id!)"
                                          (blur)="onDateInputBlur(attribute.id!)"
                                          placeholder="MM/DD/YYYY"
                                          maxlength="10"
                                          [disabled]="isSavingTruthValue">
                                        <input
                                          type="date"
                                          class="date-picker-hidden"
                                          [value]="getDatePickerValue()"
                                          (change)="onDatePickerChange($event, attribute.id!)"
                                          [disabled]="isSavingTruthValue">
                                        <span class="material-icons date-picker-icon" (mousedown)="onDatePickerIconMousedown($event)" (click)="openDatePicker($event)">calendar_today</span>
                                      </div>
                                    } @else if (getFieldType(attribute.id!) === 'select') {
                                      <select
                                        #editingInput
                                        class="truth-value-edit-input select-input"
                                        [(ngModel)]="editingTruthValueText"
                                        (change)="onSelectFieldChange($event, attribute.id!)"
                                        (blur)="onSelectBlur($event, attribute.id!)"
                                        [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                        <option value="">-- Select --</option>
                                        @for (option of getFieldAllowedValuesWithDescriptions(attribute.id!); track option.value) {
                                          <option [value]="option.value" [title]="option.fullDescription">
                                            {{ option.displayText }}
                                          </option>
                                        }
                                      </select>
                                    } @else {
                                      <textarea
                                        #editingInput
                                        class="truth-value-edit-input"
                                        [value]="editingTruthValueText"
                                        (input)="onTextFieldInput($event, attribute.id!)"
                                        (blur)="onTruthValueBlur(attribute.id!)"
                                        [placeholder]="getPlaceholderText(attribute.id!)"
                                        [disabled]="isSavingTruthValue || isCurrentFileExtracting()"
                                        rows="3"></textarea>
                                    }
                                  </div>
                                  @if (isModified(attribute.id!)) {
                                    <button class="btn-undo"
                                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                            (click)="undoChange(attribute.id!, valueIndex, $event)"
                                            title="Undo changes">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M3 7v6h6"></path>
                                        <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>
                                      </svg>
                                    </button>
                                  }
                                  @if (canSnipForAttribute(attribute.id!)) {
                                    <button type="button"
                                            class="value-box-snip-toggle"
                                            [class.has-pending]="canUndoSnipForValue(attribute.id!, valueIndex)"
                                            [disabled]="!canUndoSnipForValue(attribute.id!, valueIndex) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, valueIndex))"
                                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                            (click)="onSnipToggleClick(attribute.id!, valueIndex, $event)"
                                            [title]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                            [attr.aria-label]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box' : 'Draw bounding box'">
                                      <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, valueIndex) ? 'undo' : 'crop_free' }}</span>
                                    </button>
                                  }
                                </div>
                              } @else {
                                <!-- Not editing - show visual representation that looks like the control type -->
                                @if (getFieldType(attribute.id!) === 'date') {
                                  <div class="value-box value-box-date"
                                       [class.modified]="isModified(attribute.id!)"
                                       [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                        [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex)"
                                       [class.overridden-field]="isOverridden(attribute.id!)"
                                       [class.empty-value-box]="!valuePart.trim()"
                                       [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === valueIndex"
                                       [class.extracting-disabled]="isCurrentFileExtracting()"
                                       (mousedown)="onValueBoxMouseDown(attribute.id!, valueIndex)"
                                       (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, valueIndex)"
                                       [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to edit date'">
                                    @if (isAutoPopulated(attribute.id!)) {
                                      <span class="auto-populated-dot" 
                                            [class.overridden-dot]="isOverridden(attribute.id!)"
                                          [title]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                                    }
                                    <span class="value-text">{{ valuePart || 'MM/DD/YYYY' }}</span>
                                    @if (canSnipForAttribute(attribute.id!)) {
                                      <button type="button"
                                              class="value-box-snip-toggle"
                                              [class.has-pending]="canUndoSnipForValue(attribute.id!, valueIndex)"
                                              [disabled]="!canUndoSnipForValue(attribute.id!, valueIndex) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, valueIndex))"
                                              (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                              (click)="onSnipToggleClick(attribute.id!, valueIndex, $event)"
                                              [title]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                              [attr.aria-label]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box' : 'Draw bounding box'">
                                        <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, valueIndex) ? 'undo' : 'crop_free' }}</span>
                                      </button>
                                    }
                                    <span class="material-icons value-icon date-icon">calendar_today</span>
                                  </div>
                                } @else if (getFieldType(attribute.id!) === 'select') {
                                  <div class="value-box value-box-select"
                                       [class.modified]="isModified(attribute.id!)"
                                       [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                        [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex)"
                                       [class.overridden-field]="isOverridden(attribute.id!)"
                                       [class.empty-value-box]="!valuePart.trim()"
                                       [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === valueIndex"
                                       [class.extracting-disabled]="isCurrentFileExtracting()"
                                       (mousedown)="onValueBoxMouseDown(attribute.id!, valueIndex)"
                                       (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, valueIndex)"
                                       [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to select option'">
                                    @if (isAutoPopulated(attribute.id!)) {
                                      <span class="auto-populated-dot"
                                            [class.overridden-dot]="isOverridden(attribute.id!)"
                                          [title]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                                    }
                                    <span class="value-text">{{ valuePart || '-- Select --' }}</span>
                                    @if (canSnipForAttribute(attribute.id!)) {
                                      <button type="button"
                                              class="value-box-snip-toggle"
                                              [class.has-pending]="canUndoSnipForValue(attribute.id!, valueIndex)"
                                              [disabled]="!canUndoSnipForValue(attribute.id!, valueIndex) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, valueIndex))"
                                              (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                              (click)="onSnipToggleClick(attribute.id!, valueIndex, $event)"
                                              [title]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                              [attr.aria-label]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box' : 'Draw bounding box'">
                                        <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, valueIndex) ? 'undo' : 'crop_free' }}</span>
                                      </button>
                                    }
                                    <span class="material-icons value-icon dropdown-icon">arrow_drop_down</span>
                                  </div>
                                } @else {
                                  <div class="value-box"
                                       [class.modified]="isModified(attribute.id!)"
                                       [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                        [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex)"
                                       [class.overridden-field]="isOverridden(attribute.id!)"
                                       [class.empty-value-box]="!valuePart.trim()"
                                       [class.extracting-disabled]="isCurrentFileExtracting()"
                                       (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, valueIndex)"
                                       [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to edit'">
                                    @if (isAutoPopulated(attribute.id!)) {
                                      <span class="auto-populated-dot"
                                            [class.overridden-dot]="isOverridden(attribute.id!)"
                                          [title]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, valueIndex) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                                    }
                                    @if (valuePart.trim()) {
                                      {{ valuePart }}
                                    } @else {
                                      <span class="no-value-text">Enter value, click + to add</span>
                                    }
                                    @if (canSnipForAttribute(attribute.id!)) {
                                      <button type="button"
                                              class="value-box-snip-toggle"
                                              [class.has-pending]="canUndoSnipForValue(attribute.id!, valueIndex)"
                                              [disabled]="!canUndoSnipForValue(attribute.id!, valueIndex) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, valueIndex))"
                                              (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                              (click)="onSnipToggleClick(attribute.id!, valueIndex, $event)"
                                              [title]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                              [attr.aria-label]="canUndoSnipForValue(attribute.id!, valueIndex) ? 'Undo bounding box' : 'Draw bounding box'">
                                        <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, valueIndex) ? 'undo' : 'crop_free' }}</span>
                                      </button>
                                    }
                                  </div>
                                }
                              }
                            }
                          } @else {
                            @if (editingAttributeId === attribute.id && editingArrayIndex === 0) {
                              <div class="truth-value-wrapper">
                                <div class="value-box-edit">
                                  @if (getFieldType(attribute.id!) === 'date') {
                                    <div class="date-input-wrapper">
                                      <input
                                        #editingInput
                                        type="text"
                                        class="truth-value-edit-input date-input"
                                        [value]="editingTruthValueText"
                                        (input)="formatDateForInput($event, attribute.id!)"
                                        (keydown)="onDateKeydown($event, attribute.id!)"
                                        (blur)="onDateInputBlur(attribute.id!)"
                                        placeholder="MM/DD/YYYY"
                                        maxlength="10"
                                        [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                      <input
                                        type="date"
                                        class="date-picker-hidden"
                                        [value]="getDatePickerValue()"
                                        (change)="onDatePickerChange($event, attribute.id!)"
                                        [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                      <span class="material-icons date-picker-icon" (mousedown)="onDatePickerIconMousedown($event)" (click)="openDatePicker($event)">calendar_today</span>
                                    </div>
                                  } @else if (getFieldType(attribute.id!) === 'select') {
                                    <select
                                      #editingInput
                                      class="truth-value-edit-input select-input"
                                      [(ngModel)]="editingTruthValueText"
                                      (change)="onSelectFieldChange($event, attribute.id!)"
                                      (blur)="onSelectBlur($event, attribute.id!)"
                                      [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                      <option value="">-- Select --</option>
                                      @for (option of getFieldAllowedValuesWithDescriptions(attribute.id!); track option.value) {
                                        <option [value]="option.value" [title]="option.fullDescription">
                                          {{ option.displayText }}
                                        </option>
                                      }
                                    </select>
                                  } @else {
                                    <textarea
                                      #editingInput
                                      class="truth-value-edit-input"
                                      [value]="editingTruthValueText"
                                      (input)="onTextFieldInput($event, attribute.id!)"
                                      (blur)="onTruthValueBlur(attribute.id!)"
                                      placeholder="Type text value here..."
                                      [disabled]="isSavingTruthValue"
                                      rows="3"></textarea>
                                  }
                                </div>
                                @if (isModified(attribute.id!)) {
                                  <button class="btn-undo" 
                                          (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                          (click)="undoChange(attribute.id!, 0, $event)"
                                          title="Undo changes">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M3 7v6h6"></path>
                                      <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>
                                    </svg>
                                  </button>
                                }
                              </div>
                            } @else {
                              <!-- Not editing - show visual representation that looks like the control type -->
                              @if (getFieldType(attribute.id!) === 'date') {
                                <div class="value-box value-box-date empty-value-box"
                                     [class.modified]="isModified(attribute.id!)"
                                    [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, 0)"
                                     [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === 0"
                                     [class.extracting-disabled]="isCurrentFileExtracting()"
                                     (mousedown)="onValueBoxMouseDown(attribute.id!, 0)"
                                     (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, 0)"
                                     [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to add date'">
                                  <span class="value-text placeholder-text">MM/DD/YYYY</span>
                                  @if (canSnipForAttribute(attribute.id!)) {
                                    <button type="button"
                                            class="value-box-snip-toggle"
                                            [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                            [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                            (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                            [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                            [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                      <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                    </button>
                                  }
                                  <span class="material-icons value-icon date-icon">calendar_today</span>
                                </div>
                              } @else if (getFieldType(attribute.id!) === 'select') {
                                <div class="value-box value-box-select empty-value-box"
                                     [class.modified]="isModified(attribute.id!)"
                                    [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, 0)"
                                     [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === 0"
                                     [class.extracting-disabled]="isCurrentFileExtracting()"
                                     (mousedown)="onValueBoxMouseDown(attribute.id!, 0)"
                                     (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, 0)"
                                     [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to select option'">
                                  <span class="value-text placeholder-text">-- Select --</span>
                                  @if (canSnipForAttribute(attribute.id!)) {
                                    <button type="button"
                                            class="value-box-snip-toggle"
                                            [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                            [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                            (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                            [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                            [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                      <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                    </button>
                                  }
                                  <span class="material-icons value-icon dropdown-icon">arrow_drop_down</span>
                                </div>
                              } @else {
                                <div class="value-box empty-value-box"
                                     [class.modified]="isModified(attribute.id!)"
                                    [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicatorForIndex(attribute.id!, 0)"
                                     [class.extracting-disabled]="isCurrentFileExtracting()"
                                     (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, 0)"
                                     [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : 'Click to add value'">
                                  <span class="no-value-text">Enter the value, click + to add</span>
                                  @if (canSnipForAttribute(attribute.id!)) {
                                    <button type="button"
                                            class="value-box-snip-toggle"
                                            [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                            [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                            (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                            [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                            [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                      <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                    </button>
                                  }
                                </div>
                              }
                            }
                          }
                        </div>
                      } @else {
                        @if (editingAttributeId === attribute.id && editingArrayIndex === null) {
                          <div class="truth-value-wrapper">
                            <div class="value-box-edit">
                              @if (getFieldType(attribute.id!) === 'date') {
                                <div class="date-input-wrapper">
                                  <input
                                    type="text"
                                    class="truth-value-edit-input date-input"
                                    [value]="editingTruthValueText"
                                    (input)="formatDateForInput($event, attribute.id!)"
                                    (keydown)="onDateKeydown($event, attribute.id!)"
                                    (blur)="onDateInputBlur(attribute.id!)"
                                    placeholder="MM/DD/YYYY"
                                    maxlength="10"
                                    [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                  <input
                                    type="date"
                                    class="date-picker-hidden"
                                    [value]="getDatePickerValue()"
                                    (change)="onDatePickerChange($event, attribute.id!)"
                                    [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                  <span class="material-icons date-picker-icon" (mousedown)="onDatePickerIconMousedown($event)" (click)="openDatePicker($event)">calendar_today</span>
                                </div>
                              } @else if (getFieldType(attribute.id!) === 'select') {
                                <select
                                  class="truth-value-edit-input select-input"
                                  [(ngModel)]="editingTruthValueText"
                                  (change)="onSelectFieldChange($event, attribute.id!)"
                                  (blur)="onSelectBlur($event, attribute.id!)"
                                  [disabled]="isSavingTruthValue || isCurrentFileExtracting()">
                                  <option value="">-- Select --</option>
                                  @for (option of getFieldAllowedValuesWithDescriptions(attribute.id!); track option.value) {
                                    <option [value]="option.value" [title]="option.fullDescription">
                                      {{ option.displayText }}
                                    </option>
                                  }
                                </select>
                              } @else {
                                <textarea
                                  class="truth-value-edit-input"
                                  [value]="editingTruthValueText"
                                  (input)="onTextFieldInput($event, attribute.id!)"
                                  (blur)="onTruthValueBlur(attribute.id!)"
                                  [placeholder]="getPlaceholderText(attribute.id!)"
                                  [disabled]="isSavingTruthValue || isCurrentFileExtracting()"
                                  rows="3"></textarea>
                              }
                            </div>
                            @if (isModified(attribute.id!)) {
                              <button class="btn-undo" 
                                      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                      (click)="undoChange(attribute.id!, null, $event)"
                                      title="Undo changes">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                  <path d="M3 7v6h6"></path>
                                  <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>
                                </svg>
                              </button>
                            }
                            @if (canSnipForAttribute(attribute.id!)) {
                              <button type="button"
                                      class="value-box-snip-toggle"
                                      [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                      [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                      (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                      [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                      [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                              </button>
                            }
                          </div>
                        } @else {
                          <!-- Not editing - show visual representation that looks like the control type -->
                          @if (getFieldType(attribute.id!) === 'date') {
                            <div class="value-box value-box-date"
                                 [class.modified]="isModified(attribute.id!)"
                                 [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                 [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicator(attribute.id!)"
                                 [class.overridden-field]="isOverridden(attribute.id!)"
                                 [class.empty-value-box]="!getDisplayValue(attribute.id!).trim()"
                                 [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === null"
                                 [class.extracting-disabled]="isCurrentFileExtracting()"
                                 (mousedown)="onValueBoxMouseDown(attribute.id!, null)"
                                 (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, null)"
                                 [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : (getDisplayValue(attribute.id!).trim() ? 'Click to edit date' : 'Click to add date')">
                              @if (isAutoPopulated(attribute.id!)) {
                                <span class="auto-populated-dot"
                                      [class.overridden-dot]="isOverridden(attribute.id!)"
                                      [title]="hasAutoFilledBoundingBoxIndicator(attribute.id!) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                              }
                              <span class="value-text" [class.placeholder-text]="!getDisplayValue(attribute.id!).trim()">
                                {{ getDisplayValue(attribute.id!) || 'MM/DD/YYYY' }}
                              </span>
                              @if (canSnipForAttribute(attribute.id!)) {
                                <button type="button"
                                        class="value-box-snip-toggle"
                                        [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                        [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                        (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                        [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                        [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                  <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                </button>
                              }
                              <span class="material-icons value-icon date-icon">calendar_today</span>
                            </div>
                          } @else if (getFieldType(attribute.id!) === 'select') {
                            <div class="value-box value-box-select"
                                 [class.modified]="isModified(attribute.id!)"
                                 [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                 [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicator(attribute.id!)"
                                 [class.empty-value-box]="!getDisplayValue(attribute.id!).trim()"
                                 [class.activating]="activatingAttributeId === attribute.id && activatingArrayIndex === null"
                                 [class.extracting-disabled]="isCurrentFileExtracting()"
                                 (mousedown)="onValueBoxMouseDown(attribute.id!, null)"
                                 (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, null)"
                                 [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : (getDisplayValue(attribute.id!).trim() ? 'Click to change selection' : 'Click to select option')">
                              @if (isAutoPopulated(attribute.id!)) {
                                <span class="auto-populated-dot" [title]="hasAutoFilledBoundingBoxIndicator(attribute.id!) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                              }
                              <span class="value-text" [class.placeholder-text]="!getDisplayValue(attribute.id!).trim()">
                                {{ getDisplayValue(attribute.id!) || '-- Select --' }}
                              </span>
                              @if (canSnipForAttribute(attribute.id!)) {
                                <button type="button"
                                        class="value-box-snip-toggle"
                                        [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                        [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                        (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                        [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                        [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                  <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                </button>
                              }
                              <span class="material-icons value-icon dropdown-icon">arrow_drop_down</span>
                            </div>
                          } @else {
                            <div class="value-box"
                                 [class.modified]="isModified(attribute.id!)"
                                 [class.auto-populated]="isAutoPopulated(attribute.id!)"
                                 [class.bbox-indicated]="hasAutoFilledBoundingBoxIndicator(attribute.id!)"
                                 [class.overridden-field]="isOverridden(attribute.id!)"
                                 [class.empty-value-box]="!getDisplayValue(attribute.id!).trim()"
                                 [class.extracting-disabled]="isCurrentFileExtracting()"
                                 (click)="!isCurrentFileExtracting() && startEditingAttribute(attribute.id!, null)"
                                 [title]="isCurrentFileExtracting() ? 'Auto-filling in progress...' : (getDisplayValue(attribute.id!).trim() ? 'Click to edit' : 'Click to add value')">
                              @if (isAutoPopulated(attribute.id!)) {
                                <span class="auto-populated-dot"
                                      [class.overridden-dot]="isOverridden(attribute.id!)"
                                      [title]="hasAutoFilledBoundingBoxIndicator(attribute.id!) ? 'Auto-populated, Detected Region' : 'Auto-populated'"></span>
                              }
                              @if (getDisplayValue(attribute.id!).trim()) {
                                {{ getDisplayValue(attribute.id!) }}
                              } @else {
                                <span class="no-value-text">Enter the value, click + to add</span>
                              }
                              @if (canSnipForAttribute(attribute.id!)) {
                                <button type="button"
                                        class="value-box-snip-toggle"
                                        [class.has-pending]="canUndoSnipForValue(attribute.id!, 0)"
                                        [disabled]="!canUndoSnipForValue(attribute.id!, 0) && (isCurrentFileExtracting() || isNotApplicable(attribute.id!) || isValueBoxEmpty(attribute.id!, 0))"
                                        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                        (click)="onSnipToggleClick(attribute.id!, 0, $event)"
                                        [title]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box change' : 'Draw bounding box for this value'"
                                        [attr.aria-label]="canUndoSnipForValue(attribute.id!, 0) ? 'Undo bounding box' : 'Draw bounding box'">
                                  <span class="material-icons" aria-hidden="true">{{ canUndoSnipForValue(attribute.id!, 0) ? 'undo' : 'crop_free' }}</span>
                                </button>
                              }
                            </div>
                          }
                        }
                      }
                      @if (isSavingTruthValue && editingAttributeId === attribute.id) {
                        <div class="saving-indicator">
                          <span class="material-icons spinning">refresh</span>
                          Saving...
                        </div>
                      }
                    </div>
                  </div>
                }
              } @else if (attributes.length > 0 && filteredAttributes.length === 0) {
                <div class="empty-state-small">
                  <p>No matching attributes found</p>
                  <p class="empty-subtitle">Try a different search term</p>
                </div>
              } @else {
                <div class="empty-state-small">
                  <p>No attributes defined</p>
                  <button class="btn-primary-small" (click)="openAddAttributeDialogMethod()">
                    Add First Attribute
                  </button>
                </div>
              }
            } @else {
              <div class="empty-state-small">
                <p>{{ !selectedDocument ? 'Select a document from Accuracy page' : 'Select a file to view attributes' }}</p>
              </div>
            }
          </div>
        </div>
      </section>

      </div>
    </div>
  } @else {
    <!-- Truth Values Page -->
    <div class="page-header">
      <button class="btn-back" (click)="backToManagement()">←</button>
      <h2>
        Truth Values
        <span class="header-count">{{ getTruthValueCounts() }}</span>
      </h2>
      @if (selectedFile) {
        <p class="subtitle">{{ selectedFile.fileName }}</p>
      } @else if (isLoadingTruthValues) {
        <p class="subtitle">Loading...</p>
      }
    </div>

    <div class="truth-values-page">
      @if (isLoadingTruthValues) {
        <div class="empty-state">
          <p>Loading truth values...</p>
        </div>
      } @else if (!selectedFile) {
        <div class="empty-state">
          <p>File not found</p>
        </div>
      } @else {
        @if (truthValues.length > 0) {
          <div class="values-table">
            <table>
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (value of truthValues; track value.id) {
                  <tr>
                    <td>{{ getAttributeLabel(value.attributeId) }}</td>
                    <td>{{ value.value }}</td>
                    <td>
                      <div class="action-buttons">
                        <button *ngIf="!authService.isReadOnly"
                          class="btn-action btn-icon-only" 
                          (click)="editValue(value)"
                          title="Edit">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                          </svg>
                        </button>
                        <button *ngIf="!authService.isReadOnly"
                          class="btn-action btn-icon-only" 
                          (click)="renameValue(value)"
                          title="Rename">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                          </svg>
                        </button>
                        <button *ngIf="!authService.isReadOnly"
                          class="btn-action btn-icon-only" 
                          (click)="deleteValue(value)"
                          title="Delete">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                            <line x1="10" y1="11" x2="10" y2="17"></line>
                            <line x1="14" y1="11" x2="14" y2="17"></line>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="empty-state">
            <p>No truth values defined for this file</p>
          </div>
        }
      }
    </div>
  }
</div>

<!-- Add Loan Dialog -->
@if (showAddLoanDialog && !authService.isReadOnly) {
  <div class="dialog-overlay" (click)="closeAddLoanDialog()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Add New Loan</h3>
        <button class="btn-close" (click)="closeAddLoanDialog()">×</button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label>Loan Number</label>
          <input 
            type="text" 
            [(ngModel)]="newLoanNumber" 
            placeholder="Enter loan number (e.g., LN-2024-005)"
            class="form-control">
        </div>
        <div class="form-group">
          <label>Loan Name</label>
          <input 
            type="text" 
            [(ngModel)]="newLoanName" 
            placeholder="Enter loan name (e.g., Commercial Loan)"
            class="form-control">
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeAddLoanDialog()">Cancel</button>
        <button class="btn-primary" (click)="addLoan()">Add</button>
      </div>
    </div>
  </div>
}

<!-- Add Attribute Dialog -->
@if (showAddAttributeDialog && !authService.isReadOnly) {
  <div class="dialog-overlay" (click)="closeAddAttributeDialogMethod()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Add New Attribute</h3>
        <button class="btn-close" (click)="closeAddAttributeDialogMethod()">×</button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label>Attribute Name</label>
          <input 
            type="text" 
            [(ngModel)]="newAttributeLabel" 
            placeholder="Enter attribute name (e.g., Loan Amount)"
            class="form-control">
        </div>
        <div class="form-group">
          <label>Description (Optional)</label>
          <textarea 
            [(ngModel)]="newAttributeDescription" 
            placeholder="Enter attribute description"
            class="form-control"
            rows="3"></textarea>
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeAddAttributeDialogMethod()">Cancel</button>
        <button class="btn-primary" (click)="addAttribute()">Add</button>
      </div>
    </div>
  </div>
}

<!-- Edit Attribute Dialog -->
@if (showEditAttributeDialog && !authService.isReadOnly) {
  <div class="dialog-overlay" (click)="closeEditAttributeDialog()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Edit Attribute</h3>
        <button class="btn-close" (click)="closeEditAttributeDialog()">×</button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label>Attribute Name *</label>
          <input 
            type="text" 
            [(ngModel)]="editAttributeLabel" 
            placeholder="Enter attribute name"
            class="form-control">
        </div>
        <div class="form-group">
          <label>Description (Optional)</label>
          <textarea 
            [(ngModel)]="editAttributeDescription" 
            placeholder="Enter attribute description"
            class="form-control"
            rows="3"></textarea>
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeEditAttributeDialog()">Cancel</button>
        <button class="btn-primary" (click)="saveEditAttribute()">Save Changes</button>
      </div>
    </div>
  </div>
}

<!-- Add/Edit Value Dialog -->
@if (showDialog && !authService.isReadOnly) {
  <div class="dialog-overlay" (click)="closeDialog()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>{{ dialogMode === 'add' ? 'Add New Value' : 'Edit Value' }}</h3>
        <button class="btn-close" (click)="closeDialog()">×</button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label>Attribute</label>
          <select 
            [(ngModel)]="dialogData.key" 
            class="form-control"
            [disabled]="dialogMode === 'edit'">
            <option value="">Select an attribute</option>
            @for (attr of attributes; track attr.attributeKey) {
              <option [value]="attr.attributeKey">{{ attr.attributeLabel }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Value</label>
          <input 
            type="text" 
            [(ngModel)]="dialogData.value" 
            placeholder="Enter value"
            class="form-control">
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeDialog()">Cancel</button>
        <button class="btn-primary" (click)="saveValue()">
          {{ dialogMode === 'add' ? 'Add' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Global Tooltip -->
@if (tooltipVisible && tooltipText) {
  <div class="global-tooltip" 
       [style.top.px]="tooltipTop" 
       [style.left.px]="tooltipLeft">
    {{ tooltipText }}
  </div>
}

